import { Component, EventEmitter, Input, Output } from '@angular/core';
import { formatDate } from '@angular/common';
import { Account } from '@services/accounts.service';

@Component({
  selector: 'app-account-expiry',
  templateUrl: './account-expiry.component.html',
  styleUrls: ['./account-expiry.component.scss'],
})
export class AccountExpiryComponent {

  /** Selected Account */
  @Input() selectedAccount: Account;

  @Input() Banner: boolean = false;

  @Input() pill: boolean = false;

  /**
   * Checks if the account is expired based on the expiry date
   * @returns 
   */
  isExpired(expiry: Date | string | number): boolean {

    if (this.selectedAccount.Expiry == 0) {
      return false;
    }

    const diffDays = this.getDaysUntilExpiry(expiry);
    if (diffDays < 0) {
      return true;
    }
    return false;
  }

  /**
   * Calculates the number of days until the expiry date   
   * @param expiry 
   * @returns 
   */
  getDaysUntilExpiry(expiry: Date | string | number): number {
    
    const expiryDate = new Date(expiry);
    const today = new Date();
    return Math.round((expiryDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

  }

  /**
   * Generates a trial message based on the expiry date
   * @returns 
   */
  getTrialMessage(expiryMSG: string, expiry: Date | string | number): string {

    if (this.selectedAccount.Expiry== 0) {
      return expiryMSG;
    }

    const formattedDate = formatDate(expiry, 'dd-MMM-yyyy', 'en-GB');
    // If already expired or within current month → check days
    const diffDays = this.getDaysUntilExpiry(expiry);

    switch (diffDays) {
      case 0:
        expiryMSG += ` expiring today (${formattedDate})`;
        break;
      case 1:
        expiryMSG += ` expiring tomorrow (${formattedDate})`;
        break;
      default:
        if (diffDays > 1 && diffDays <= 30) {
          expiryMSG += ` expiring soon in ${diffDays} day${diffDays > 1 ? "s" : ""} (${formattedDate})`;
        } else if (diffDays < 0) {
          expiryMSG += ` expired on ${formattedDate}`;
        }
    }

    return expiryMSG;
  }

}
